import store from '../../../../store'
import inbox_table from './list.vue';


window.INBOX =  new Vue({
    store,
    el: '#inbox_items',
    name : "Memorandum Inbox",
    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },
    components : {
        inbox_table
    }
});
